// @ts-nocheck
export const actionableStyles = `
  /* Menu */
  .sonataMenu {
    display: none !important;
  }

  /* Reporting header */
  .reportingHeader,
  .actionButton,
  .multiHeader__editSection,
  .logo__upload {
    display: none !important;
  }

  /* Multicampaign switch container */
  .reportingCampaignListContainer {
    display: none !important;
  }

  /* Static report disclaimer */
  .staticReportModeDisclaimer .closeStaticModeMessage {
    display: none !important;
  }

  /* Filter section */
  .reportingAdvancedFilterResumePanel__header__buttonGroup {
    display: none !important;
  }

  /* Campaign Summary */
  .reportingOverviewAnalyticalSwitch, 
  .sectionHeader__buttonContainer,
  .reportingOverview__downloadContainer,
  .reportingOverviewSwitch {
    display: none !important;
  }

  /* Multicampaign list campaings */
  .reportingCampaignItemDetailsFilters {
    display: none !important;
  }

  /* Charts section */
  .reportingCharts .tabsComponent__titleContainer,
  .impressionsKpisChart__selectorsContainer,
  .impressionsKpisChart__switchLegend,
  .changeLogButtonWrapper {
    display: none !important;
  }

  /* Insights section */
  .reportingInsights__downloadContainer,
  .reportingInsightsGroupItem__header,
  .reportingInsightsGroupItem__config,
  .reportingInsightsItem__filters-item,
  .insightsChartItem__showMoreButtonWrapper {
    display: none !important;
  }

  /* New stats table section */
  .StatsTable .reportFilters,
  .StatsTable .columnSettings {
    display: none !important;
  }

  /* Old stats table section */
  .statsContainer .sectionTitle, 
  .statsContainer .tableFilterDataSelector, 
  .statsContainer .tableTools {
    display: none !important;
  }

  /* Maps */
  .mapView .footfallAttributionMapSelectors__selectorsSection,
  .mapView .variableSettings__container,
  .mapboxgl-ctrl,
  .mapContainer__controlPanel,
  .mapRankingRightPanel .checkboxContainer,
  .mapRankingRightPanel .buttonsContainer,
  .mapContainer__mapsContainer .checkboxContainer {
    display: none !important;
  }

`;
